import React from 'react';
import PropTypes from 'prop-types';
import { Header } from 'rsuite';
import styled from 'styled-components';

const StyledHeading = styled.h4`
  margin: 20px 0;
`;

const PageHeader = ({ title, children, ...rest }) => (
  <Header {...rest}>
    <StyledHeading>{title}</StyledHeading>
    {children}
  </Header>
);

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node
};

PageHeader.defaultProps = {
  children: ''
};

export default PageHeader;
